export {CrudDataGenericService} from './crud-data-generic.service';
export {GeneralMessages} from './general-messages-generic.service';



// WEBPACK FOOTER //
// ./src/app/shared/services/index.ts